import { useEffect, useState } from 'react'
import { useNavigation } from 'react-router'

function EpicProgress() {
	const navigation = useNavigation()
	const busy = navigation.state !== 'idle'
	const [phase, setPhase] = useState<
		'idle' | 'growing' | 'completing' | 'fading'
	>('idle')

	// idle → growing
	useEffect(() => {
		if (busy && phase === 'idle') {
			setPhase('growing')
		}
	}, [busy, phase])

	// growing → completing (when navigation finishes)
	useEffect(() => {
		if (!busy && phase === 'growing') {
			setPhase('completing')
		}
	}, [busy, phase])

	// completing → fading (after bar reaches 100%)
	useEffect(() => {
		if (phase === 'completing') {
			const timer = setTimeout(() => setPhase('fading'), 200)
			return () => clearTimeout(timer)
		}
	}, [phase])

	// fading → idle (after fade-out finishes)
	useEffect(() => {
		if (phase === 'fading') {
			const timer = setTimeout(() => setPhase('idle'), 300)
			return () => clearTimeout(timer)
		}
	}, [phase])

	if (phase === 'idle') return null

	return (
		<div
			role="progressbar"
			aria-valuetext={busy ? 'Loading' : undefined}
			className="fixed inset-x-0 top-0 z-[60] h-[2px]"
		>
			<div
				style={{
					boxShadow: '0 0 8px var(--primary)',
					width:
						phase === 'growing'
							? '85%'
							: phase === 'completing' || phase === 'fading'
								? '100%'
								: '0%',
					opacity: phase === 'fading' ? 0 : 1,
					transition:
						phase === 'growing'
							? 'width 8s cubic-bezier(0.1, 0.05, 0, 1)'
							: phase === 'completing'
								? 'width 200ms ease-out'
								: 'opacity 300ms ease-out',
				}}
				className="bg-gradient-brand h-full"
			/>
		</div>
	)
}

export { EpicProgress }
